<template>
  <div>
    <div
      class="flex select-none items-center space-x-2"
      :class="{ 'opacity-50': disabled }"
    >
      <input
        :id="id || internalId"
        v-model="internalValue"
        :name="name"
        type="radio"
        :value="value"
        :disabled="disabled"
        class="size-5 rounded-full border border-gray-90 text-white focus:outline-none enabled:cursor-pointer"
      />
      <label v-if="label || hasLabel" :for="id || internalId">
        <slot name="label">
          <span class="text-xs font-light font-normal">{{ label }} </span>
        </slot>
      </label>
    </div>

    <FieldHint
      v-if="!hideDetails"
      :error="Boolean(errorMessage)"
      :message="errorMessage || hint"
    />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import FieldHint from "~/components/shared/FieldHint.vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean | string | number | null | Array<any>;
    name: string;
    value: string;
    id?: string;
    label?: string;
    hideDetails?: boolean;
    disabled?: boolean;
    hint?: string;
  }>(),
  {
    id: "",
    label: "",
    hint: "",
  },
);

const emit = defineEmits(["update:modelValue"]);

const slots = useSlots();

// const internalId = generateString();
const internalId = useId();
const name = toRef(props, "name");
const { errorMessage, handleChange } = useField(name, undefined, {
  initialValue: props.modelValue,
});

const hasLabel = computed(() => {
  return !!slots.label;
});

const internalValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (props.name) {
      // handleChange(props.modelValue);
      handleChange(newValue);
    }
    emit("update:modelValue", newValue);
  },
});
</script>
